// src/components/AdminDashboard/RoleBadge.js
import React from 'react';

const getRoleColor = (role) => {
  switch (role) {
    case 'admin': return 'bg-red-100 text-red-800';
    case 'professor': return 'bg-blue-100 text-blue-800';
    case 'student': return 'bg-green-100 text-green-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

const RoleBadge = ({ role }) => (
  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getRoleColor(role)}`}>
    {role}
  </span>
);

export default RoleBadge;
